<template>
    <div class="app-contacts-contacts-import">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Importar</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <!-- Formulário para importar contatos -->
        <mu-form-import></mu-form-import>

    </div>
</template>

<script>
    export default {
        name: 'app-contacts-contacts-dashboard',
        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Contatos',
                        route: 'app.contacts',
                        disabled: false
                    },
                    {
                        text: 'Importação',
                        route: 'app.contacts.import',
                        disabled: false
                    },
                    {
                        text: 'Criar Importação',
                        disabled: true
                    }
                ]
            }
        }
    }
</script>
